import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-39107684"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pxMoney" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "$", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElInput = _resolveComponent("ElInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ElInput, {
      modelValue: _ctx.innerValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.innerValue) = $event)),
      name: _ctx.name,
      placeholder: _ctx.placeholderText,
      class: "pxMoney-input",
      formatter: 
        (value) => {
          // Remove non-numeric characters and format with commas
          return value.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
      ,
      parser: 
        (value) => {
          // Remove non-numeric characters
          return value.replace(/\D/g, '');
        }
      
    }, {
      prefix: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["modelValue", "name", "placeholder", "formatter", "parser"])
  ]))
}